import React from 'react';
import { RotateCcw } from 'react-feather';

import Paging from '@/shared/components/Common/Paging';
import SearchBar from '@/shared/components/Common/SearchBar';
import { useInitialPage } from '@/shared/hooks/useInitialPage';
import { useUserList } from './hooks/useUserList';

import UserListTable from './components/UI/UserListTable';

const UserListPage: React.FC = () => {
  useInitialPage();
  const {
    users,
    currentPage,
    totalPages,
    keyword,
    isLoading,
    hasError,
    isEmpty,
    shouldReset,
    totalCount,
    handlePageChange,
    handleSearch,
    handleReset,
    handleResetComplete,
    handleRefresh,
    error,
  } = useUserList();

  return (
    <main className="flex h-screen flex-col bg-[#F1F1F1]" role="main">
      <div className="flex h-full flex-col px-10 pb-0 pt-6">
        <div className="mb-9 flex items-center justify-between">
          <h1
            className="text-2xl font-bold text-[#1D1D1D]"
            id="user-list-title"
          >
            User
          </h1>
        </div>

        <div className="mb-5 flex items-center justify-between">
          <span
            className="w-32 rounded-md bg-[#707070] px-4 py-1 text-center text-sm text-white"
            aria-label="Total number of customers"
          >
            {totalCount} Customers
          </span>
          <button
            type="button"
            className="flex h-7 w-7 cursor-pointer items-center justify-center rounded bg-[#E2E2E2] transition-colors hover:bg-opacity-80"
            onClick={handleReset}
            disabled={isLoading}
          >
            <RotateCcw size={16} className="text-[#1D1D1D]" />
          </button>
        </div>

        <SearchBar
          onSearch={handleSearch}
          shouldReset={shouldReset}
          onResetComplete={handleResetComplete}
          initialValue={keyword}
        />

        <UserListTable
          users={users}
          isLoading={isLoading}
          hasError={hasError}
          isEmpty={isEmpty}
          error={error}
        />

        {!isLoading && !hasError && totalPages > 0 && (
          <div className="flex-none border border-x-[#DEDEDE] bg-[#E8E8E8] pb-4 pt-3">
            <Paging
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
              totalPage={totalPages}
            />
          </div>
        )}
      </div>
    </main>
  );
};

export default UserListPage;
